import { useEffect, useState } from "react";
import { CloseButton, Col, Container, FormGroup } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import PaginateCard from "../../components/PaginateCard";
import Laoder from "../../components/loading/Loader";
import PrintLink from "../../components/shipment/Factor/PrintLink";
import Card from "../../components/ui/div/Card";
import CompanyEnum from "../../enums/company/CompanyEnum";
import useUserInformation from "../../hooks/useUserInformation";
import { getAuthMethod } from "../../modules/helper";
import MainMenu from "../../modules/public/mainMenu/mainMenu";
import ExcelWallet from "./components/ExcelWallet";
import style from "./show.module.css";

function ShowWallet() {
  const { isSupervisor, isDistrictManger, isAgent } = useUserInformation();

  const [state, setState] = useState({
    data: [],
    partsdetails: [],
    status: "اننخاب نشده",
    company: 0,
    id: "",
    sDateMyPack: "",
    eDateMyPack: "",
    answer: "",
    modalShow: false,
    showNumber: 10,
    pageNumber: 1,
    active: 1,
    paginationlength: 1,
    startNumber: 0,
    sendItem: "",
    print: false,
    itemprint: "",
    logo: "",
    currentCredit: 0,
    loading: false,
    UI: "",
    walletType: 0,
    count: 0,
    numberParcelUniqueCount: 0,
  });

  const getData = async () => {
    const params = {
      numberpage: state.pageNumber || 1,
      numberitems: state.showNumber || 10,
      barname: state.barname || undefined,
      company: state.company || undefined,
      fromDate: state.sDateMyPack || undefined,
      toDate: state.eDateMyPack || undefined,
      walletType: state.walletType || undefined,
      isDirect: state.isDirect ? 1 : undefined,
    };

    setState(cur => ({ ...cur, loading: true }));
    const datas = await getAuthMethod("/wallet/v1/collector", params);
    setState(cur => ({ ...cur, loading: false }));

    if (datas && datas.status === 200) {
      setState(cur => ({
        ...cur,
        UI: datas.data.data.UI,
        currentCredit: datas.data.data.amont,
        data: datas.data.data.all,
        paginationlength: datas.data.data.number,
        startNumber: (state.pageNumber - 1) * state.showNumber + 1,
        count: datas.data.data.count,
        numberParcelUniqueCount: datas.data.data.numberParcelUniqueCount,
      }));
    }
  };

  const setInputNumber = event => {
    setState(cur => ({
      ...cur,
      showNumber: event.target.value,
      pageNumber: 1,
    }));
  };

  const onDateChange = (date, key) => {
    if (!date) {
      setState(cur => ({ ...cur, [key]: undefined }));
      return;
    }

    setState(cur => ({ ...cur, [key]: new DateObject(date) }));
  };

  useEffect(() => {
    getData();
  }, [state.showNumber, state.pageNumber]);

  const countUi = (
    <div className="mt-4 mb-1">
      <p className="text-success fw-bold m-0">
        <span>تعداد رکورد: </span>
        <span>{state.count?.toLocaleString()}</span>
      </p>
      <p className="text-success fw-bold m-0">
        <span>تعداد مرسوله: </span>
        <span>{state.numberParcelUniqueCount?.toLocaleString()}</span>
      </p>
    </div>
  );

  const table = (
    <div className="w-100 overflow-x-auto">
      <Table striped bordered={true} className="text-center">
        <thead>
          <tr>
            <th>#</th>
            <th>شماره بارنامه</th>
            <th>مبلغ</th>
            <th>موجودی</th>
            <th>وضعیت</th>
            <th>پیام</th>
            <th>تاریخ</th>
          </tr>
        </thead>
        <tbody>
          {state.loading === true && (
            <tr>
              <td colSpan="7">
                <Laoder />
              </td>
            </tr>
          )}
          {state.loading === false &&
            state.data.map((user, index) => (
              <tr key={index}>
                <td>{index + state.startNumber}</td>
                <td>
                  <PrintLink ids={[user.item.numberParcel]} byNumberParcel>
                    {user.item.numberParcel}
                  </PrintLink>
                </td>
                <td>{user.item.amount?.toLocaleString()}</td>
                <td>{user.item.cash?.toLocaleString()}</td>
                <td>{user.item.status}</td>
                <td>{user.item.description}</td>
                <td>
                  {user.date} - {user.time}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );

  const optionArew = (
    <Card className="my-3 w-100 d-flex flex-wrap gap-3">
      <Col xs="12" sm="5" lg="3" xxl="2">
        <Form.Label> تعداد نمایشی:</Form.Label>
        <Form.Select id="disabledSelect" onChange={setInputNumber}>
          <option>10</option>
          <option>20</option>
          <option>50</option>
          <option>100</option>
        </Form.Select>
      </Col>

      <Col xs="12" sm="5" lg="3" xxl="2">
        <FormGroup>
          <Form.Label> سرویس دهنده:</Form.Label>

          <Form.Select
            onChange={e =>
              setState(cur => ({ ...cur, company: parseInt(e.target.value) }))
            }
          >
            <option value="">همه</option>

            {Object.keys(CompanyEnum).map(item => (
              <option value={item} key={item}>
                {CompanyEnum[item]}
              </option>
            ))}
          </Form.Select>
        </FormGroup>
      </Col>

      <Col xs="12" sm="5" lg="3" xxl="2">
        <FormGroup>
          <Form.Label> شماره بارنامه:</Form.Label>
          <Form.Control
            type="number"
            onChange={e =>
              setState(cur => ({ ...cur, barname: e.target.value }))
            }
          />
        </FormGroup>
      </Col>

      <Col
        xs="12"
        sm="6"
        lg="4"
        xxl="3"
        className="d-flex border border-1 rounded align-self-end align-items-center gap-2 px-2"
        style={{ height: 38 }}
      >
        <Form.Check
          id="walletDirectTransactions"
          onChange={e =>
            setState(cur => ({ ...cur, isDirect: e.target.checked }))
          }
        />
        <Form.Label
          htmlFor="walletDirectTransactions"
          className="c-pointer user-select-none m-0"
        >
          تراکنش های مستقیم
        </Form.Label>
      </Col>

      {(isSupervisor || isDistrictManger) && (
        <Col xs="12" sm="5" lg="3" xxl="2">
          <Form.Label>نوع:</Form.Label>
          <Form.Select
            onChange={e =>
              setState(cur => ({
                ...cur,
                walletType: parseInt(e.target.value),
              }))
            }
          >
            <option value={0}>همه</option>
            {isSupervisor && <option value={1}>سرپرستی</option>}
            {isDistrictManger && <option value={2}>مدیر منطقه</option>}
            {isAgent && <option value={3}>نمایندگی</option>}
          </Form.Select>
        </Col>
      )}

      <div className="w-100 d-flex flex-wrap gap-3">
        <Col xs="12" sm="5" lg="3" xxl="2">
          <Form.Label className="d-block">از تاریخ:</Form.Label>
          <div className="d-flex">
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              style={{ width: "100%", height: "2.2rem" }}
              name="sDateMyPack"
              value={state.sDateMyPack}
              onChange={date => onDateChange(date, "sDateMyPack")}
            />
            <div
              onClick={() => setState(cur => ({ ...cur, sDateMyPack: "" }))}
              className={style.closeButton}
            >
              <CloseButton />
            </div>
          </div>
        </Col>

        <Col xs="12" sm="5" lg="3" xxl="2">
          <Form.Label className="d-block">تا تاریخ:</Form.Label>
          <div className="d-flex">
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              style={{ width: "100%", height: "2.2rem" }}
              name="eDateMyPack"
              value={state.eDateMyPack}
              onChange={date => onDateChange(date, "eDateMyPack")}
            />
            <div
              onClick={() => setState(cur => ({ ...cur, eDateMyPack: "" }))}
              className={style.closeButton}
            >
              <CloseButton />
            </div>
          </div>
        </Col>

        <Col
          xs="12"
          sm="5"
          lg="3"
          xxl="2"
          className="me-auto d-flex justify-content-end align-items-end"
        >
          <Button
            className="mt-4"
            onClick={() => {
              if (state.pageNumber === 1) getData();
              else setState(cur => ({ ...cur, pageNumber: 1 }));
            }}
          >
            اعمال فیلتر
          </Button>
        </Col>
      </div>
    </Card>
  );

  const paginate = (
    <div className="mb-4">
      <PaginateCard
        count={state.count}
        numberItems={state.showNumber}
        numberPage={state.pageNumber}
        onIndexChoose={number =>
          setState(cur => ({ ...cur, pageNumber: number }))
        }
      />
    </div>
  );

  return (
    <MainMenu>
      <Container>
        <div className="text-center h5 text-danger my-1">
          موجودی کیف پول شما: {state.currentCredit.toLocaleString()}
        </div>
        {optionArew}
        {countUi}
        {table}
        {paginate}
        <ExcelWallet state={state} />
      </Container>
    </MainMenu>
  );
}

export default ShowWallet;
